import React, { useState, useEffect } from 'react'
import { Checkbox } from 'react-bootstrap'

export const StringList = ({ items = [], onChange }) => {
    const [stringInput, setStringInput] = useState('')
    const [strings, setString] = useState(items)

    const addString = () => {
        if (strings.includes(stringInput)) return
        if (!stringInput || stringInput.length < 1) return

        setString(strings.concat(stringInput))
        setStringInput('')

    }

    useEffect(() => onChange(strings), [strings])

    return (
        <div>
            <div style={{ backgroundColor: 'white', padding: 5, border: '1px solid lightgrey' }}>

                {!strings.length ? '-' : null}
                {strings.map((string, i) => {
                    return <p key={i} style={{ fontSize: "1.4rem", margin: 5 }}>{string} <SimpleButton text="Ta bort" onClick={() => setString(strings.filter(s => s !== string))} /></p>
                })}
            </div>

            <br />

            <div>

                <input type="text" value={stringInput} onChange={(e) => setStringInput(e.target.value)} onKeyDown={(e) => { if (e.keyCode === 13) addString() }} />
                &nbsp;
                <SimpleButton text="Spara" onClick={() => {
                    addString()
                }} />

            </div>


        </div>
    )
}

export const PercentageSelect = ({ presetValue = null, onChange }) => {
    const percentages = '10 20 30 40 50 60 70 80 90 100'.split(' ').map(v => parseInt(v))

    return (
        <div>
            <select onChange={(e) => onChange(e.target.value)} style={{ backgroundColor: 'white' }}>
                {percentages.map(p => <option key={p} selected={presetValue === p ? p : null} value={p}>{p}%</option>)}
            </select>
        </div>
    )
}

export const YesNoSelect = ({ presetValue = null, onChange }) => {
    const options = [{ label: 'Ja', value: true }, { label: 'Nej', value: false }]
    return (
        <div>
            <select onChange={(e) => onChange(e.target.value)} style={{ backgroundColor: 'white' }}>
                {options.map(p => <option key={p.label} selected={presetValue === p.value ? p.label : null} value={p.value}>{p.label}</option>)}
            </select>
        </div>
    )
}

export const SimpleButton = ({ text, onClick }) => {
    return (
        <button style={{ border: '1px solid grey', padding: 5 }} onClick={onClick}>{text}</button>
    )
}

export const MultipleCheckbox = ({ reportChange, options }) => {
    const [checkedItems, setCheckedItems] = useState([])

    const itemClicked = (option) => {
        let newArray = [...checkedItems]

        newArray = newArray.filter(f => f.value !== option.value)

        if (newArray.length === checkedItems.length) newArray.push(option)

        setCheckedItems(newArray)
    }

    useEffect(() => reportChange(checkedItems), [checkedItems])

    return (
        <div>
            {options.map((option, i) => {
                return (
                    <div key={i}>
                        <Checkbox key={option.value} onClick={() => itemClicked(option)} defaultChecked={checkedItems.includes(option.value)}>
                            {option.label}
                        </Checkbox>
                    </div>)
            })}
        </div>
    )
}